module.exports = __webpack_public_path__ + "img/icon-03.a9e589df.png";